import { prop, curryN, chain, compose } from 'ramda';
import { Maybe } from 'true-myth';

type UnaryFunc<A, R> = (a: A) => R;

// Samma som vanliga map från ramda, men med bättre typning för att mappa på maybe.
// ramdas typning ska också fungera, men den här kan ge mer läsbara fel om typen inte stämmer.
// prettier-ignore
export const mapM: <A, B>( fn: UnaryFunc<A, NonNullable<B>> ) => UnaryFunc<Maybe<A>, Maybe<B>> =
fn => aMaybe => aMaybe.map(fn);

// Gör om en funktion som kan returnera null/undefined till en funktion som returnerar Maybe
export const safe: any = function safe<a, b>(
  fn: (p: a) => b | undefined | null
): (p: a) => Maybe<b> {
  return compose(Maybe.fromNullable, fn);
};

// applicerar en funktion som ger nullable på samma sätt som en som ger Maybe
export const chainSafe = compose<any, any>(chain, safe);

export const maybeProp: (name: string) => (p: any) => Maybe<any> = curryN(
  2,
  compose(Maybe.fromNullable, prop)
);

const throwMessage: <T>(p: string) => () => Maybe<T> = message => () => {
  throw new Error(message);
};

export const orThrow =
  (message: string) =>
  <T>(aMaybe: Maybe<T>): T => {
    return Maybe.unsafelyUnwrap(aMaybe.orElse(throwMessage<T>(message)));
  };
